// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__zFz4t","header":"PatientQuestionnaire_header__2BXPf","info":"PatientQuestionnaire_info__3PUy1"};